import React, { useEffect, useState } from 'react';
import { Button, Col, Drawer, Form, Input, message, Row, Select } from 'antd';
import { dispatch, useGlobalState } from '../../../store/state';
import './BrandProfileComponent.styles.scss';
import { GetProfileDetails } from '../../../apis/Brand/Profile/GetProfileDetails';
import { UpdateProfileDetails } from '../../../apis/Brand/Profile/UpdateProfileDetails';
import { AppLogout } from '../../../utils/AppLogout';
import { Config } from '../../../Config';
import { validatorGSTIN, validatorPAN, validatorPINCODE } from '../../../utils';
import { GetCountryDetails } from '../../../apis/Brand/Profile/GetCountryDetails';

const { Item } = Form;
const { Option } = Select;
const BrandBillingDetails = ({ visible, onClose }) => {
  const [user] = useGlobalState('user');
  const [stateList, setStateList] = useState([]);
  // const
  // const [profileBasicForm] = Form.useForm()
  useEffect(()=>{
    GetProfileDetails(user.accessToken).then(({ response, status }) =>{
      console.log('prof response', response);
      if (status === 200) {
        dispatch({
          type: 'SET_USER',
          payload: {
            ...user,
            email: response.email,
            phone: response.phone,
          },
        });
      } else if (status === 404) {
        AppLogout();
      } else {
        message.error('There is some issue with getting your profile details');
      }
    });

    // get state List
    GetCountryDetails().then((res) =>{
      console.log('res', res[Config.country]);
      setStateList(res[Config.country].states);
    });
  }, []);

  // render state List
  // useEffect(() =>{

  // },[])

  // @note: to update basic details of profile
  const onBillingDetailsUpdate = (_v) =>{
    const _data = {
      address: {
        line1: _v.line1,
        line2: _v.line2,
        city: _v.city,
        pin: _v.pin,
        state: _v.state,
        country: _v.country,
      },
      gst: {
        gstin: _v.gstin,
        businessName: _v.businessName,
      },
      pan: _v.pan,
    };
    UpdateProfileDetails(user.accessToken, _data).then(({ status, response })=>{
      console.log('update response', response);
      if (status === 200) {
        dispatch({
          type: 'SET_USER',
          payload: {
            ...user,
            ..._data,
          },
        });
        message.success('Profile Updated Successfully!');
      } else {
        message.error('There is some issue with your profile update');
      }
    });
  };
  return (
    <div>
      <h4 className="profile_basics--title">Billing Details</h4>
      <Form
        // form={profileBasicForm}
        onFinish={onBillingDetailsUpdate}
        className="profile_basics_form"
        name="profileBillinForm"
        layout="vertical"
        requiredMark={false}
        initialValues={{
          'line1': user.address.line1 || undefined,
          'line2': user.address.line2 || undefined,
          'city': user.address.city || undefined,
          'pin': user.address.pin || undefined,
          'state': user.address.state || undefined,
          'country': user.address.country || Config.country,
          'gstin': user.gst.gstin || undefined,
          'businessName': user.gst.businessName || undefined,
          'pan': user.pan || undefined,
        }}
      >
        <Item
          label="Address line 1"
          name="line1"
          rules={[
            { required: true, message: 'This field can\'t be empty' },
          ]}
        >
          <Input className="common_input"
            placeholder="Eg: No.10, Apartment name"/>
        </Item>
        <Item
          label="Address line 2"
          name="line2"
          rules={[
            { required: true, message: 'This field can\'t be empty' },
          ]}
        >
          <Input className="common_input"
            placeholder="Eg: Street name, locality"/>
        </Item>
        <Row gutter={12}>
          <Col span={15}>
            <Item
              label="City"
              name="city"
              rules={[
                { required: true, message: 'City name required' },
              ]}
            >
              <Input className="common_input"
                placeholder="City name"/>
            </Item>
          </Col>
          <Col span={9}>
            <Item
              label="Pin Code"
              name="pin"
              rules={[
                { required: true, message: 'Pincode required' },
                {
                  validator: (_, value)=>{
                    if (value && !validatorPINCODE(value)) {
                      return Promise.reject(new Error('Invalid Pincode'));
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
            >
              <Input type="number"
                className="common_input"
                placeholder="Pincode"/>
            </Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={15}>
            <Item
              label="State"
              name="state"

              rules={[
                { required: true, message: 'This field can\'t be empty' },
              ]}
            >
              <Select showSearch
                placeholder="Select your state"
                className="common_select">
                {
                  stateList.map(({ code, name })=>(
                    <Option key={code}
                      value={name}>{name} [{code}]</Option>
                  ))
                }
              </Select>
            </Item>
          </Col>
          <Col span={9}>
            <Item
              label="Country"
              name="country"
              rules={[
                { required: true, message: 'This field can\'t be empty' },
              ]}
            >
              <Select disabled={true}
                placeholder="Select your country"
                className="common_select">
                <Option>India</Option>
              </Select>
            </Item>
          </Col>
        </Row>
        <Item
          label="GSTIN"
          name="gstin"
          rules={[
            { required: true, message: 'This field can\'t be empty' },
            {
              validator: (_, value)=>{
                if (value && !validatorGSTIN(value)) {
                  return Promise.reject(new Error('Not a valid GSTIN code'));
                } else {
                  return Promise.resolve();
                }
              },
            },
          ]}
        >
          <Input className="common_input"
            placeholder="Your Business GSTIN CODE"/>
        </Item>
        <Item
          label="Business Name"
          name="businessName"
          rules={[
            { required: true, message: 'This field can\'t be empty' },
          ]}
        >
          <Input className="common_input"
            placeholder="Provide business name"/>
        </Item>
        <Item
          label="PAN"
          name="pan"
          rules={[
            { required: true, message: 'This field can\'t be empty' },
            {
              validator: (_, value)=>{
                if (value && !validatorPAN(value)) {
                  return Promise.reject(new Error('Not a valid PAN'));
                } else {
                  return Promise.resolve();
                }
              },
            },
          ]}
        >
          <Input placeholder="Your Business PAN"
            className="common_input"/>
        </Item>

        <Item>
          <Button htmlType="submit"
            className="common_button outlined mt-2 py-2 w-100">Update Billing Details</Button>
        </Item>
      </Form>
    </div>
  );
};

export default BrandBillingDetails;
